import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const location = useLocation();
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
  const closeNavbar = () => setIsNavCollapsed(true);

  return (
    <div>
      <div className="container-fluid">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            <a className="navbar-brand" href="#">
              <i className="fa-solid fa-vault fs-3"></i>
            </a>
            <button
              className={`navbar-toggler ${isNavCollapsed ? "collapsed" : ""}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded={!isNavCollapsed}
              aria-label="Toggle navigation"
              onClick={handleNavCollapse}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className={`collapse navbar-collapse ${isNavCollapsed ? "" : "show"}`}
              id="navbarNav"
            >
              <ul className="navbar-nav margin_left_nav fw-semibold font_size_navbr_items gap_navbar_items">
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
                    to="/"
                    onClick={closeNavbar}
                  >
                    HOME
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === "/loancal" ? "active" : ""}`}
                    to="/loancal"
                    onClick={closeNavbar}
                  >
                    LOAN CAL
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === "/investone" ? "active" : ""}`}
                    to="/investone"
                    onClick={closeNavbar}
                  >
                    INVEST ONE
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === "/investtwo" ? "active" : ""}`}
                    to="/investtwo"
                    onClick={closeNavbar}
                  >
                    INVEST TWO
                  </Link>
                </li>
              </ul>
              <div className="d-flex justify-content-center align-items-center">
                <div
                  className="bg-black flurentpink rounded-5 px-3 py-2 font_size_navbr_items width_contact_us d-flex justify-content-center align-items-center"
                  aria-current="page"
                >
                  CONTACT US
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
